import React from "react";
import { Typography } from "@mui/material";

export default function Note({ note, udyamNote = "", ...props }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        marginTop: udyamNote === "udyamNote" ? "-5px" : "24px",
        paddingBottom: "24px",
        ...props.noteStyle,
      }}
    >
      <img src="/assets/note.svg" alt="note" width="18px" height="18px" />
      <Typography variant="subtitle" sx={{ color: "#1D1E24", ml: 1 }}>
        {note}
      </Typography>
    </div>
  );
}
